module.exports = "https://trybtryb-legacy.web.app/img/edit.872978a6.svg";